export default __webpack_public_path__ + "media/images/images_v2/modifier-7824757bd1f7e531ce113782debc1890.png";